module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/hero-526d96be8d0e34ca1f7cfc0723cff624.jpg";